module.exports = __webpack_public_path__ + "static/media/img20.c9c675b6.png";